// extracted by mini-css-extract-plugin
export default {"dob_input":"teacher_dob_input__-zPzD","gender_container":"teacher_gender_container__kvwwU"};